/* eslint-disable max-lines-per-function, import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
// @ts-expect-error TS(6133): 'React' is declared but its value is never read.
import React, { useState, useEffect, useRef } from "react";
import { cn } from "tailwind-variants";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import {
  trackRudderstackImageEdited,
  trackRudderstackImageUploadError
} from "common/utils/rudderstack/tracker.react";
import { getStickerDimensions } from "common/utils/stickers";
// @ts-expect-error TS(7016): Could not find a declaration file for module 'ua-p... Remove this comment to see the full error message
import UAParser from "ua-parser-js";
// @ts-expect-error TS(7016): Could not find a declaration file for module 'loda... Remove this comment to see the full error message
import isEqual from "lodash.isequal";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import StepNumber from "./common/StepNumber.vue";
import { useSpanglesStore, SPANGLE_MODES } from "./spangles-module";
import { useI18n } from "intl/useI18n";
import { useDtfStore } from "./store";
import {
  MIN_DIMENSION_SIZE,
  MIN_DPI,
  PRINT_AS_IS_MIN_DPI,
  PRINT_AS_IS_MAX_HEIGHT,
  PRINT_AS_IS_MIN_WIDTH,
  MAX_SIZE_FIELD_VALUE,
  UPSCALE_THRESHOLD,
  DEFAULT_VALUES,
  GANG_DEFAULT_VALUES,
  MIN_DIMENSION_PUFF
} from "./common/constants";
import "./ArtworkDimensions.scss";

export default function ArtworkDimensions({
  artwork = null,
  index = 0,
  disabled = false,
  readonly = false,
  widthDefault = null,
  currentStore = null,
  isMultiUpload = false,
  ...restProps
}) {
  const { n } = useI18n();

  const [newWidth, setNewWidth] = useState(null);
  const [newHeight, setNewHeight] = useState(null);
  const [oldWidth, setOldWidth] = useState(null);
  const [oldHeight, setOldHeight] = useState(null);
  const [isHeightValid, setIsHeightValid] = useState(true);
  const [isWidthValid, setIsWidthValid] = useState(true);
  const [previousData, setPreviousData] = useState({
    width: null,
    height: null
  });
  const [sizeChanged, setSizeChanged] = useState(false);

  const store = useDtfStore();
  const spanglesStore = useSpanglesStore();
  const prevArtworkRef = useRef(artwork);

  function variantId() {
    // @ts-expect-error TS(4111): Property 'variantId' comes from an index signature... Remove this comment to see the full error message
    return store.variantId;
  }

  function simulation() {
    // @ts-expect-error TS(4111): Property 'simulation' comes from an index signatur... Remove this comment to see the full error message
    return store.simulation;
  }

  function printAsIs() {
    // @ts-expect-error TS(4111): Property 'printAsIs' comes from an index signature... Remove this comment to see the full error message
    return store.printAsIs;
  }

  function isPuff() {
    // @ts-expect-error TS(4111): Property 'isPuff' comes from an index signature, s... Remove this comment to see the full error message
    return store.isPuff;
  }

  function pdpType() {
    // @ts-expect-error TS(4111): Property 'pdpType' comes from an index signature, ... Remove this comment to see the full error message
    return store.pdpType;
  }

  // @ts-expect-error TS(6133): 'catalogNumber' is declared but its value is never... Remove this comment to see the full error message
  function catalogNumber() {
    // @ts-expect-error TS(4111): Property 'catalogNumber' comes from an index signa... Remove this comment to see the full error message
    return store.catalogNumber;
  }

  // @ts-expect-error TS(6133): 'dpiInstructionsUrl' is declared but its value is ... Remove this comment to see the full error message
  function dpiInstructionsUrl() {
    // @ts-expect-error TS(4111): Property 'dpiInstructionsUrl' comes from an index ... Remove this comment to see the full error message
    return store.dpiInstructionsUrl;
  }

  function showModal() {
    // @ts-expect-error TS(4111): Property 'showModal' comes from an index signature... Remove this comment to see the full error message
    return store.showModal;
  }

  function dtfMaxWidth() {
    // @ts-expect-error TS(4111): Property 'dtfMaxWidth' comes from an index signatu... Remove this comment to see the full error message
    return store.dtfMaxWidth;
  }

  function dtfMaxHeight() {
    // @ts-expect-error TS(4111): Property 'dtfMaxHeight' comes from an index signat... Remove this comment to see the full error message
    return store.dtfMaxHeight;
  }

  function dtfMinWidth() {
    // @ts-expect-error TS(4111): Property 'dtfMinWidth' comes from an index signatu... Remove this comment to see the full error message
    return store.dtfMinWidth;
  }

  function dtfMinHeight() {
    // @ts-expect-error TS(4111): Property 'dtfMinHeight' comes from an index signat... Remove this comment to see the full error message
    return store.dtfMinHeight;
  }

  function errorTypes() {
    // @ts-expect-error TS(4111): Property 'errorTypes' comes from an index signatur... Remove this comment to see the full error message
    return store.errorTypes;
  }

  function isSpangle() {
    // @ts-expect-error TS(4111): Property 'isSpangle' comes from an index signature... Remove this comment to see the full error message
    return store.isSpangle;
  }

  function sticker() {
    // @ts-expect-error TS(4111): Property 'sticker' comes from an index signature, ... Remove this comment to see the full error message
    return store.sticker;
  }

  function businessLine() {
    // @ts-expect-error TS(4111): Property 'businessLine' comes from an index signat... Remove this comment to see the full error message
    return store.businessLine;
  }

  function showStepsUI() {
    // @ts-expect-error TS(4111): Property 'showStepsUI' comes from an index signatu... Remove this comment to see the full error message
    return store.showStepsUI;
  }

  function isStandardArtwork() {
    // @ts-expect-error TS(4111): Property 'isStandardArtwork' comes from an index s... Remove this comment to see the full error message
    return store.isStandardArtwork;
  }

  function isProColor() {
    // @ts-expect-error TS(4111): Property 'isProColor' comes from an index signatur... Remove this comment to see the full error message
    return store.isProColor;
  }

  function artworks() {
    // @ts-expect-error TS(4111): Property 'artworks' comes from an index signature,... Remove this comment to see the full error message
    return store.artworks;
  }

  function preCut() {
    // @ts-expect-error TS(4111): Property 'preCut' comes from an index signature, s... Remove this comment to see the full error message
    return store.preCut;
  }

  function spangleSizeEdited() {
    // @ts-expect-error TS(4111): Property 'spangleSizeEdited' comes from an index s... Remove this comment to see the full error message
    return spanglesStore.spangleSizeEdited;
  }

  function isInitialSpangle() {
    // @ts-expect-error TS(4111): Property 'isInitialSpangle' comes from an index si... Remove this comment to see the full error message
    return spanglesStore.isInitialSpangle;
  }

  function validationError() {
    // @ts-expect-error TS(2339): Property 'errorMessage' does not exist on type 'ne... Remove this comment to see the full error message
    return artwork?.errorMessage;
  }

  function validationErrorType() {
    // @ts-expect-error TS(2339): Property 'errorType' does not exist on type 'never... Remove this comment to see the full error message
    return artwork?.errorType;
  }

  function gangPadlock() {
    return printAsIs() && !showModal();
  }

  function lockHeight() {
    return gangPadlock() && !!metadata();
  }

  function readonlyHeight() {
    if (showModal() && printAsIs()) return readonly;
    if (!lockHeight()) return false;
    return readonly;
  }

  function minDpi() {
    if (printAsIs()) return PRINT_AS_IS_MIN_DPI;
    return metadata()?.upscalingEnabled ? Number(metadata().qualityUpscaleDpi) : MIN_DPI;
  }

  function pricing() {
    // @ts-expect-error TS(2339): Property 'pricing' does not exist on type 'never'.
    return artwork?.pricing || simulation();
  }

  function priceInch() {
    if (pricing()?.pricePerInch) {
      return Number(pricing().pricePerInch).toFixed(4);
    }
    return null;
  }

  function totalPrice() {
    if (pricing()?.transferPrice) {
      return Number(pricing().transferPrice).toFixed(2) || "";
    }
    return null;
  }

  function widthId() {
    return `artwork[${index}][variants][${variantId()}][width]`;
  }

  function heightId() {
    return `artwork[${index}][variants][${variantId()}][height]`;
  }

  function metadata() {
    // @ts-expect-error TS(2339): Property 'removeBackground' does not exist on type... Remove this comment to see the full error message
    const { removeBackground, metadata: artworkMetadata, withBgMetadata } = artwork || {};
    if (!withBgMetadata || Object.keys(withBgMetadata).length === 0) {
      return artworkMetadata;
    }
    return removeBackground ? artworkMetadata : withBgMetadata;
  }

  function width() {
    // @ts-expect-error TS(2339): Property 'previewMetadata' does not exist on type ... Remove this comment to see the full error message
    return artwork?.previewMetadata?.widthInch || artwork?.width || widthDefault;
  }

  function height() {
    // @ts-expect-error TS(2339): Property 'height' does not exist on type 'never'.
    const artworkHeight = artwork?.height;
    if (printAsIs() && !!metadata()) {
      // @ts-expect-error TS(2531): Object is possibly 'null'.
      return artwork.lengthFoot;
    }
    return artworkHeight;
  }

  function heightLabel() {
    const unit = printAsIs() ? "" : "(inches)";
    const label = printAsIs() ? "Length (feet)" : "Height"; // eslint-disable-line no-shadow
    return showBorderUI() ? label : `${label} ${unit}`;
  }

  function showPaddingNote() {
    return !isSpangle() && !printAsIs() && !isPuff();
  }

  function paddingNote() {
    return sticker()
      ? "Padding for easy peeling is added for free"
      : "Padding for easy cutting is added for free";
  }

  function heightName() {
    return printAsIs() ? "length" : "height";
  }

  function minWidthSetting() {
    return printAsIs() ? PRINT_AS_IS_MIN_WIDTH : dtfMinWidth();
  }

  function isWidthAndHeightValid() {
    return (
      width() !== "" &&
      Number(width()) >= minWidth() &&
      height() !== "" &&
      Number(height()) >= minHeight()
    );
  }

  function fitsGangSheet() {
    return (
      width() !== "" &&
      height() !== "" &&
      Math.min(width(), height()) <= metadata()?.maxSheetWidth &&
      Math.max(width(), height()) <= metadata()?.maxSheetHeight
    );
  }

  // @ts-expect-error TS(6133): 'dpi' is declared but its value is never read.
  function dpi() {
    return Math.round(metadata().width / width());
  }

  function imageMetadataInfo() {
    if (!metadata()) return null;
    return {
      aspect_ratio: metadata().aspectRatio,
      resolution_width: metadata().width,
      resolution_height: metadata().height,
      width: width(),
      height: height(),
      max_width: metadata().maxWidth,
      max_height: metadata().maxHeight,
      max_sheet_width: metadata().maxSheetWidth,
      max_sheet_height: metadata().maxSheetHeight,
      min_dpi: minDpi(),
      // @ts-expect-error TS(2531): Object is possibly 'null'.
      file_name: artwork.name,
      // @ts-expect-error TS(2531): Object is possibly 'null'.
      file_size: artwork.fileSize,
      // @ts-expect-error TS(2531): Object is possibly 'null'.
      file_type: artwork.fileType
    };
  }

  function isUpscaleThresholdExceeded() {
    if (isSpangle()) return false;
    // @ts-expect-error TS(2339): Property 'originalWidth' does not exist on type 'n... Remove this comment to see the full error message
    const { originalWidth, originalHeight, width: artworkWidth, height: artworkHeight } = artwork;
    if (!originalWidth || !originalHeight || !artworkWidth || !artworkHeight) return false;
    const newWidth = parseFloat(artworkWidth); // eslint-disable-line no-shadow
    const newHeight = parseFloat(artworkHeight); // eslint-disable-line no-shadow
    const upscaleFactorWidth = (newWidth / originalWidth).toFixed(2);
    const upscaleFactorHeight = (newHeight / originalHeight).toFixed(2);
    // @ts-expect-error TS(2345): Argument of type 'string' is not assignable to par... Remove this comment to see the full error message
    const upscaleFactor = Math.min(upscaleFactorWidth, upscaleFactorHeight);
    return upscaleFactor > UPSCALE_THRESHOLD;
  }

  function showSpangleEditSize() {
    return isSpangle() && !isInitialSpangle();
  }

  function minSizeForProduct() {
    if (
      width() === null ||
      width() === undefined ||
      width() === "" ||
      height() === null ||
      height() === undefined ||
      height() === ""
    ) {
      return true;
    }
    const widthNum = Number(width());
    const heightNum = Number(height());
    if (Number.isNaN(widthNum) || Number.isNaN(heightNum)) {
      return true;
    }
    if (isSpangle()) {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      return widthNum >= dtfMinWidth() && heightNum >= dtfMinHeight();
    }
    if (sticker()) {
      return widthNum >= MIN_DIMENSION_SIZE && heightNum >= MIN_DIMENSION_SIZE;
    }
    if (isPuff()) {
      return widthNum >= MIN_DIMENSION_PUFF.width && heightNum >= MIN_DIMENSION_PUFF.height;
    }
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return widthNum >= dtfMinWidth() && heightNum >= dtfMinHeight();
  }

  function label() {
    if (isPuff() || sticker()) {
      return "Select size";
    }
    if (isSpangle()) {
      return "Design size";
    }
    return null;
  }

  function isInvalid() {
    return showBorderUI() && validationError() && (!isWidthValid || !isHeightValid);
  }

  function showBorderUI() {
    return showStepsUI() && !isMultiUpload;
  }

  function editType() {
    if (sizeChanged) {
      return "Size Adjustment";
    }
    // @ts-expect-error TS(2339): Property 'enhanceImage' does not exist on type 'ne... Remove this comment to see the full error message
    if (artwork?.enhanceImage) {
      return "Jiffy Print Perfect";
    }
    return "Print as uploaded";
  }

  function minWidth() {
    return isPuff() ? MIN_DIMENSION_PUFF.width : MIN_DIMENSION_SIZE;
  }

  function minHeight() {
    return isPuff() ? MIN_DIMENSION_PUFF.height : MIN_DIMENSION_SIZE;
  }

  function minDimensions() {
    if (isPuff()) {
      return {
        width: MIN_DIMENSION_PUFF.width,
        height: MIN_DIMENSION_PUFF.height
      };
    }
    return {
      width: minWidthSetting(),
      height: dtfMinHeight()
    };
  }

  function updateArtworkValues(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return store.updateArtworkValues(...args);
  }

  function setValidationErrorMessage(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return store.setValidationErrorMessage(...args);
  }

  function setSpangleMode(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return spanglesStore.setSpangleMode(...args);
  }

  function getArtworksPricing(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return store.getArtworksPricing(...args);
  }

  function updatePdpDates(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return store.updatePdpDates(...args);
  }

  function updatePreviewDpi(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return store.updatePreviewDpi(...args);
  }

  function downscaleOriginalImage(...args: any[]) {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    return store.downscaleOriginalImage(...args);
  }

  function handleInput(dimensionType: any, e: any) {
    let { value } = e.target;
    if (printAsIs() && dimensionType === "height" && value > MAX_SIZE_FIELD_VALUE) {
      value = MAX_SIZE_FIELD_VALUE;
    }
    autoFillInputs(dimensionType, value);
  }

  function handleInputClick(e: any) {
    e.target.focus();
  }

  function handleFocusIn() {
    setOldWidth(newWidth);
    setOldHeight(newHeight);
  }

  function handleWidthInput(e: any) {
    handleInput("width", e);
  }

  function handleHeightInput(e: any) {
    handleInput("height", e);
  }

  function autoFillInputs(field: any, value: any) {
    if (!artwork) return;
    let newDimensions = {
      // @ts-expect-error TS(2339): Property 'width' does not exist on type 'never'.
      width: artwork.width,
      // @ts-expect-error TS(2339): Property 'height' does not exist on type 'never'.
      height: artwork.height
    };
    if (Number(value) > MAX_SIZE_FIELD_VALUE) {
      value = MAX_SIZE_FIELD_VALUE;
    }
    if (field === "width") {
      newDimensions = {
        width: value,
        height: getProportionalEdge(value, "height"),
        // @ts-expect-error TS(2322): Type '{ width: any; height: any; widthEdited: bool... Remove this comment to see the full error message
        widthEdited: true
      };
    }
    if (field === "height") {
      newDimensions = {
        width: getProportionalEdge(value, "width"),
        height: value
      };
    }
    setNewWidth(newDimensions.width);
    setNewHeight(newDimensions.height);
    updateArtworkValues({
      // @ts-expect-error TS(2339): Property 'originalIndex' does not exist on type 'n... Remove this comment to see the full error message
      index: artwork.originalIndex,
      ...newDimensions
    });
    updatePreviewDpi({
      // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
      artworkId: artwork.id
    });
    downscaleOriginalImage({
      // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
      artworkId: artwork.id
    });
  }

  function getProportionalEdge(value: any, field: any) {
    // @ts-expect-error TS(2531): Object is possibly 'null'.
    if (!metadata()?.aspectRatio) return artwork[field];
    const factor = field === "height" ? 1 / metadata().aspectRatio : metadata().aspectRatio;
    const otherEdge = Math.round(value * factor * 100) / 100;
    return otherEdge.toFixed(2) || null;
  }

  function sendValidationWarning(sendEvent: any) {
    if (!sendEvent) return;
    // @ts-expect-error TS(2339): Property 'metadata' does not exist on type 'never'... Remove this comment to see the full error message
    const warning = artwork?.metadata?.warnings?.keys[0];
    if (!printAsIs() || !warning) return;
    sendWarningEvent("image_validation_warning", warning);
  }

  function validateValues(sendEvent = false) {
    setValidationError(sendEvent);
    if (!metadata()) {
      setIsHeightValid(isWidthAndHeightValid());
      setIsWidthValid(isWidthAndHeightValid());
      return;
    }
    sendValidationWarning(sendEvent);
    const widthConstraint =
      metadata().aspectRatio > 1 ? metadata().maxSheetHeight : metadata().maxSheetWidth;
    const heightConstraint =
      metadata().aspectRatio > 1 ? metadata().maxSheetWidth : metadata().maxSheetHeight;
    setIsWidthValid(
      fitsGangSheet() ? isWidthAndHeightValid() : width() !== "" && width() <= widthConstraint
    );
    setIsHeightValid(
      fitsGangSheet() ? isWidthAndHeightValid() : height() !== "" && height() <= heightConstraint
    );
  }

  function setValidationError(sendEvent: any) {
    // @ts-expect-error TS(2339): Property 'isSimulated' does not exist on type 'nev... Remove this comment to see the full error message
    if (printAsIs() && !artwork?.isSimulated) return;
    const isInvalid = // eslint-disable-line no-shadow
      invalidWidthValidation(sendEvent) ||
      invalidHeightValidation(sendEvent) ||
      negativeValuesValidation(sendEvent) ||
      minPrintSizeValidation(sendEvent) ||
      maxPrintSizeValidation(sendEvent) ||
      maxPrintSizePrintAsIsValidation() ||
      upscaleThresholdExceeded(sendEvent);
    if (!isInvalid) {
      setValidationErrorMessage({
        index,
        message: null,
        type: null
      });
    }
  }

  function invalidWidthValidation(sendEvent = false) {
    if (width() !== "") return false;
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    if (validationErrorType() !== errorTypes().INVALID_WIDTH && sendEvent) {
      sendValidationEvent("image_validation_error", "invalid_width", {});
    }
    setValidationErrorMessage({
      index,
      message: "Please enter a valid width.",
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      type: errorTypes().INVALID_WIDTH
    });
    return true;
  }

  function invalidHeightValidation(sendEvent = false) {
    if (height() !== "") return false;
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    if (validationErrorType() !== errorTypes().INVALID_HEIGHT && sendEvent) {
      sendValidationEvent("image_validation_error", "invalid_height", {});
    }
    setValidationErrorMessage({
      index,
      message: `Please enter a valid ${heightName()}.`,
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      type: errorTypes().INVALID_HEIGHT
    });
    return true;
  }

  function negativeValuesValidation(sendEvent = false) {
    if (width() >= 0 && height() >= 0) return false;
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    if (validationErrorType() !== errorTypes().NEGATIVE_VALUES && sendEvent) {
      sendValidationEvent("image_validation_error", "negative_values", {
        width: width(),
        height: height()
      });
    }
    setValidationErrorMessage({
      index,
      message: "Negative values are not permitted.",
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      type: errorTypes().NEGATIVE_VALUES
    });
    return true;
  }

  function minPrintSizeValidation(sendEvent = false) {
    if (minSizeForProduct()) return false;
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    if (validationErrorType() !== errorTypes().MIN_PRINT_SIZE && sendEvent) {
      if (showSpangleEditSize()) {
        setSpangleMode(SPANGLE_MODES.editSize);
      }
      sendValidationEvent("image_validation_error", "min_print_size", {});
    }
    const unit = printAsIs() ? "'" : '"';
    setValidationErrorMessage({
      index,
      message: `The minimum print size is ${minDimensions().width}" x ${minDimensions().height}${unit}`,
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      type: errorTypes().MIN_PRINT_SIZE
    });
    return true;
  }

  function maxPrintSizeValidation(sendEvent = false) {
    if (printAsIs() || fitsGangSheet()) return false;
    let maxSheetWidth = dtfMaxWidth();
    let maxSheetHeight = dtfMaxHeight();
    if (metadata() && metadata().maxSheetHeight && metadata().maxSheetWidth) {
      maxSheetWidth =
        metadata().aspectRatio > 1 ? metadata().maxSheetHeight : metadata().maxSheetWidth;
      maxSheetHeight =
        metadata().aspectRatio > 1 ? metadata().maxSheetWidth : metadata().maxSheetHeight;
    }
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    if (Number(width()) <= maxSheetWidth && Number(height()) <= maxSheetHeight) {
      return false;
    }
    if (
      sticker() &&
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      Number(previousData.width) <= maxSheetWidth &&
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      Number(previousData.height) <= maxSheetHeight
    ) {
      return false;
    }
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    if (validationErrorType() !== errorTypes().MAX_PRINT_SIZE && sendEvent) {
      if (showSpangleEditSize()) {
        setSpangleMode(SPANGLE_MODES.editSize);
      }
      sendValidationEvent("image_validation_error", "max_print_size", {});
    }
    const message = `The maximum print size is ${maxSheetWidth}" x ${maxSheetHeight}"`;
    setValidationErrorMessage({
      index,
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      type: errorTypes().MAX_PRINT_SIZE,
      message
    });
    return true;
  }

  function upscaleThresholdExceeded(sendEvent = false) {
    if (printAsIs() || !isUpscaleThresholdExceeded()) return false;
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    if (validationErrorType() !== errorTypes().UPSCALE_THRESHOLD_EXCEEDED && sendEvent) {
      sendValidationEvent("image_validation_error", "upscale_threshold_exceeded", {});
    }
    setValidationErrorMessage({
      index,
      message: "upscale_threshold_exceeded",
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      type: errorTypes().UPSCALE_THRESHOLD_EXCEEDED
    });
    return true;
  }

  function maxPrintSizePrintAsIsValidation() {
    if (printAsIs() && height() > (metadata()?.maxSheetHeight || PRINT_AS_IS_MAX_HEIGHT)) {
      setValidationErrorMessage({
        index,
        message: `The maximum print size is ${PRINT_AS_IS_MIN_WIDTH}" x ${PRINT_AS_IS_MAX_HEIGHT}'`,
        type: null
      });
      return true;
    }
    return false;
  }

  function sendValidationEvent(eventType: any, errorType: any, data: any) {
    let metadataObj = {
      ...data,
      // @ts-expect-error TS(2339): Property 'isFile' does not exist on type 'never'.
      has_image: !artwork?.isFile && !artwork?.isSimulated,
      pdp_type: pdpType(),
      business_line: businessLine(),
      page: "pdp"
    };
    // @ts-expect-error TS(2339): Property 'isFile' does not exist on type 'never'.
    if (!artwork?.isFile) {
      metadataObj = {
        ...metadataObj,
        ...imageMetadataInfo()
      };
    }
    submitDtfEvent(eventType, {
      type: errorType,
      ...metadataObj
    });
    trackRudderstackImageUploadError({
      error_message: errorType,
      business_line: businessLine(),
      location: "pdp",
      pre_cut_transfers: preCut()
    });
  }

  function sendWarningEvent(eventType: any, warningType: any) {
    const metadataObj = {
      ...imageMetadataInfo(),
      // @ts-expect-error TS(2339): Property 'isFile' does not exist on type 'never'.
      has_image: !artwork?.isFile && !artwork?.isSimulated,
      pdp_type: pdpType(),
      business_line: businessLine(),
      page: "pdp"
    };
    submitDtfEvent(eventType, {
      type: warningType,
      ...metadataObj
    });
  }

  async function updateArtworksPricingAndTrackSizeChange(
    oldArtworkPrice: any,
    newArtworkPrice: any
  ) {
    const detectProductLine = (obj: any) => {
      if (obj.sticker) return "sticker";
      if (obj.isProColor) return "pro color";
      if (obj.isSpangle) return "spangle";
      return "dtf";
    };
    const eventPayload = {
      product_line: detectProductLine({
        sticker: sticker(),
        isProColor: isProColor(),
        isSpangle: isSpangle()
      }),
      business_line: businessLine(),
      artwork,
      edit_type: editType(),
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      artworks_count: artworks().length,
      location: "pdp",
      old_price: oldArtworkPrice,
      new_price: newArtworkPrice,
      pre_cut_transfers: preCut()
    };
    setSizeChanged(false);
    trackRudderstackImageEdited(eventPayload);
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    store.reindexArtworks();
  }

  function trackSizeChanges() {
    if (newWidth === oldWidth && newHeight === oldHeight) return;
    let sizeChange;
    // @ts-expect-error TS(2531): Object is possibly 'null'.
    const area = newWidth * newHeight;
    // @ts-expect-error TS(2531): Object is possibly 'null'.
    const oldArea = oldWidth * oldHeight;
    if (area === 0 && oldArea === 0) {
      sizeChange = "none";
    } else if (area > oldArea) {
      sizeChange = "larger";
    } else {
      sizeChange = "smaller";
    }
    const sizePercentChange =
      oldArea === 0 ? 0 : Math.round((Math.abs(area - oldArea) / oldArea) * 100);
    submitDtfEvent("size_modified", {
      width: newWidth,
      height: newHeight,
      previous_width: oldWidth ?? width(),
      previous_height: oldHeight ?? height(),
      size_change: sizeChange,
      business_line: businessLine(),
      size_percent_change: sizePercentChange,
      has_image: !simulation(),
      page: "pdp",
      pdp_type: pdpType()
    });
  }

  function onBlur() {
    const currentData = {
      width: width(),
      height: height()
    };
    if (isEqual(currentData, previousData)) {
      return;
    }
    validateValues(true);
    if (isWidthAndHeightValid()) {
      setPreviousData(currentData);
      getArtworksPricing();
      updatePdpDates();
      trackSizeChanges();
      setSizeChanged(true);
    }
  }

  // @ts-expect-error TS(6133): 'openZendeskChat' is declared but its value is nev... Remove this comment to see the full error message
  function openZendeskChat() {
    // @ts-expect-error TS(2339): Property 'zE' does not exist on type 'Window & typ... Remove this comment to see the full error message
    if (!window.zE) return;
    const device = new UAParser().getDevice();
    if (["mobile", "tablet"].includes(device.type)) return;
    // @ts-expect-error TS(2339): Property 'zE' does not exist on type 'Window & typ... Remove this comment to see the full error message
    window.zE(() => {
      // @ts-expect-error TS(2339): Property 'zE' does not exist on type 'Window & typ... Remove this comment to see the full error message
      window.zE("messenger", "open");
    });
  }

  useEffect(() => {
    const dimensions = printAsIs() ? GANG_DEFAULT_VALUES : DEFAULT_VALUES;
    setPreviousData({
      // @ts-expect-error TS(2322): Type 'number' is not assignable to type 'null'.
      width: dimensions.width,
      // @ts-expect-error TS(2322): Type 'number' is not assignable to type 'null'.
      height: dimensions.height
    });
  }, []);

  useEffect(() => {
    if (!artwork) return;

    const oldArtwork = prevArtworkRef.current;
    prevArtworkRef.current = artwork;

    // @ts-expect-error TS(2339): Property 'isFile' does not exist on type 'never'.
    if (artwork.isFile || artwork.isSimulated) return;
    // @ts-expect-error TS(2339): Property 'metadata' does not exist on type 'never'... Remove this comment to see the full error message
    if (!!artwork.metadata?.errors && !artwork.isValid) return;

    // @ts-expect-error TS(2339): Property 'originalIndex' does not exist on type 'n... Remove this comment to see the full error message
    if (artwork.originalIndex && artwork.originalIndex !== index) {
      updateArtworkValues({
        // @ts-expect-error TS(2339): Property 'originalIndex' does not exist on type 'n... Remove this comment to see the full error message
        index: artwork.originalIndex,
        originalIndex: index
      });
      getArtworksPricing();
      return;
    }

    // @ts-expect-error TS(2339): Property 'width' does not exist on type 'never'.
    const newArtworkSize = `${artwork.width}${artwork.height}`;
    // @ts-expect-error TS(2339): Property 'width' does not exist on type 'never'.
    const oldArtworkSize = `${oldArtwork?.width}${oldArtwork?.height}`;

    const triggerValidateOnSpangleSizeEdit =
      isSpangle() && spangleSizeEdited() && newArtworkSize !== oldArtworkSize;

    const enhancementSwitched =
      // @ts-expect-error TS(2339): Property 'enhanceImage' does not exist on type 'ne... Remove this comment to see the full error message
      isStandardArtwork() && artwork.enhanceImage !== oldArtwork?.enhanceImage;

    if (
      // @ts-expect-error TS(2339): Property 'isLoading' does not exist on type 'never... Remove this comment to see the full error message
      (oldArtwork?.isLoading && !artwork.isLoading) ||
      // @ts-expect-error TS(2339): Property 'removeBackground' does not exist on type... Remove this comment to see the full error message
      oldArtwork?.removeBackground !== artwork.removeBackground ||
      triggerValidateOnSpangleSizeEdit ||
      enhancementSwitched
    ) {
      if (sticker()) {
        // @ts-expect-error TS(2339): Property 'originalWidth' does not exist on type 'n... Remove this comment to see the full error message
        const skipDefaultCheck = artwork.originalWidth !== artwork.width;
        const newPreviousData = getStickerDimensions(
          // @ts-expect-error TS(2339): Property 'width' does not exist on type 'never'.
          artwork.width,
          // @ts-expect-error TS(2339): Property 'height' does not exist on type 'never'.
          artwork.height,
          skipDefaultCheck
        );
        // @ts-expect-error TS(2345): Argument of type '{ width: string; height: string;... Remove this comment to see the full error message
        setPreviousData(newPreviousData);
        updateArtworkValues({
          // @ts-expect-error TS(2339): Property 'originalIndex' does not exist on type 'n... Remove this comment to see the full error message
          index: artwork.originalIndex,
          ...newPreviousData
        });
        getArtworksPricing();
      } else {
        setPreviousData({
          // @ts-expect-error TS(2339): Property 'width' does not exist on type 'never'.
          width: artwork.width,
          // @ts-expect-error TS(2339): Property 'height' does not exist on type 'never'.
          height: artwork.height
        });
      }
      validateValues(true);
    }

    if (
      // @ts-expect-error TS(2339): Property 'pricing' does not exist on type 'never'.
      artwork.pricing &&
      // @ts-expect-error TS(2339): Property 'pricing' does not exist on type 'never'.
      oldArtwork?.pricing &&
      // @ts-expect-error TS(2339): Property 'pricing' does not exist on type 'never'.
      !isEqual(artwork.pricing.unitPrice, oldArtwork.pricing.unitPrice)
    ) {
      updateArtworksPricingAndTrackSizeChange(
        // @ts-expect-error TS(2339): Property 'pricing' does not exist on type 'never'.
        oldArtwork.pricing.unitPrice,
        // @ts-expect-error TS(2339): Property 'pricing' does not exist on type 'never'.
        artwork.pricing.unitPrice
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    // @ts-expect-error TS(2339): Property 'isLoading' does not exist on type 'never'.
    artwork?.isLoading,
    // @ts-expect-error TS(2339): Property 'removeBackground' does not exist on type 'never'.
    artwork?.removeBackground,
    // @ts-expect-error TS(2339): Property 'enhanceImage' does not exist on type 'never'.
    artwork?.enhanceImage,
    // @ts-expect-error TS(2339): Property 'originalIndex' does not exist on type 'never'.
    artwork?.originalIndex,
    // @ts-expect-error TS(2339): Property 'width' does not exist on type 'never'.
    artwork?.width,
    // @ts-expect-error TS(2339): Property 'height' does not exist on type 'never'.
    artwork?.height,
    // @ts-expect-error TS(2339): Property 'originalWidth' does not exist on type 'never'.
    artwork?.originalWidth,
    // @ts-expect-error TS(2339): Property 'isFile' does not exist on type 'never'.
    artwork?.isFile,
    // @ts-expect-error TS(2339): Property 'isSimulated' does not exist on type 'never'.
    artwork?.isSimulated,
    // @ts-expect-error TS(2339): Property 'isValid' does not exist on type 'never'.
    artwork?.isValid,
    // @ts-expect-error TS(2339): Property 'metadata' does not exist on type 'never'.
    artwork?.metadata?.errors,
    // @ts-expect-error TS(2339): Property 'pricing' does not exist on type 'never'.
    artwork?.pricing?.unitPrice
  ]);

  return (
    <div
      {...restProps}
      // @ts-expect-error TS(4111): Property 'className' comes from an index signature... Remove this comment to see the full error message
      className={cn("artwork-dimensions scope-6b9e2e48", restProps?.className, {
        "artwork-dimensions--with-border": showBorderUI(),
        "artwork-dimensions--with-border-invalid": isInvalid()
      })}
    >
      {label() && !showBorderUI() ? (
        <div className="artwork-dimensions__label scope-6b9e2e48">{label()}</div>
      ) : null}
      {showBorderUI() ? (
        <StepNumber
          className="scope-6b9e2e48"
          stepNumber={isPuff() ? 3 : 2}
          content="Set Design Size"
          data-testid="step-number"
        />
      ) : null}
      <div
        className="artwork-dimensions__form-number-row scope-6b9e2e48"
        data-testid="artwork-dimensions-form-row"
      >
        <div className="artwork-dimensions__form-number-group scope-6b9e2e48">
          <label
            className={cn("artwork-dimensions__number-label scope-6b9e2e48", {
              "artwork-dimensions__number-label--gang": printAsIs()
            })}
            htmlFor={widthId()}
            data-testid="artwork-dimensions-number-label"
          >
            {" "}
            Width {!showBorderUI() ? <> (inches)</> : null}
          </label>
          <div
            className={cn("artwork-dimensions__number-control scope-6b9e2e48", {
              "artwork-dimensions__number-control--gang-lock": gangPadlock() && !!width()
            })}
          >
            <input
              className={cn("artwork-dimensions__number-field js-dtf-width-input scope-6b9e2e48", {
                "artwork-dimensions__number-field--invalid": validationError() && !isWidthValid
              })}
              id={widthId()}
              value={width()}
              max="100"
              min="0.1"
              name={widthId()}
              step=".01"
              type="number"
              data-hj-allow={true}
              disabled={disabled}
              readOnly={readonly || !!widthDefault}
              onClick={handleInputClick}
              onChange={handleWidthInput}
              onFocus={handleFocusIn}
              onBlur={onBlur}
              data-testid="artwork-dimensions-number-field"
            />
          </div>
        </div>
        <UseSvg
          className={cn("artwork-dimensions__multiplier scope-6b9e2e48", {
            "artwork-dimensions__multiplier--gang": printAsIs()
          })}
          icon="cross"
          data-testid="artwork-dimensions-multiplier"
        />

        <div className="artwork-dimensions__form-number-group scope-6b9e2e48">
          <label
            className={cn("artwork-dimensions__number-label scope-6b9e2e48", {
              "artwork-dimensions__number-label--gang": printAsIs()
            })}
            htmlFor={heightId()}
            data-testid="artwork-dimensions-number-label-1"
          >
            {heightLabel()}
          </label>
          <div
            className={cn("artwork-dimensions__number-control scope-6b9e2e48", {
              "artwork-dimensions__number-control--gang-lock": lockHeight()
            })}
          >
            <input
              className={cn("artwork-dimensions__number-field js-dtf-height-input scope-6b9e2e48", {
                "artwork-dimensions__number-field--invalid": validationError() && !isHeightValid
              })}
              id={heightId()}
              value={height()}
              max="100"
              min="0.1"
              name={heightId()}
              step=".01"
              type="number"
              data-hj-allow={true}
              disabled={disabled}
              readOnly={readonlyHeight()}
              onClick={handleInputClick}
              onChange={handleHeightInput}
              onFocus={handleFocusIn}
              onBlur={onBlur}
              data-testid="artwork-dimensions-number-field-1"
            />
          </div>
        </div>
        <UseSvg
          className="artwork-dimensions__multiplier scope-6b9e2e48"
          icon="cross"
          data-testid="artwork-dimensions-multiplier-1"
        />

        <div className="artwork-dimensions__form-number-group artwork-dimensions__form-number-group--price scope-6b9e2e48">
          {printAsIs() ? (
            <div className="artwork-dimensions__number-label artwork-dimensions__number-label--gang scope-6b9e2e48">
              {" "}
              Linear foot <br className="scope-6b9e2e48" /> price{" "}
            </div>
          ) : (
            <div
              className={cn("artwork-dimensions__number-label scope-6b9e2e48", {
                "artwork-dimensions__number-label--light": showBorderUI()
              })}
            >
              {" "}
              Price / in²{" "}
            </div>
          )}
          <div className="artwork-dimensions__static-input scope-6b9e2e48">
            {/* @ts-expect-error TS(2345): Argument of type 'string | null' is not assignable... Remove this comment to see the full error message */}
            {n(priceInch(), "currencyDetailed")}
          </div>
        </div>
        <div className="artwork-dimensions__equal-sign scope-6b9e2e48">=</div>
        <div className="artwork-dimensions__form-number-group artwork-dimensions__form-number-group--price scope-6b9e2e48">
          {printAsIs() ? (
            <div className="artwork-dimensions__number-label artwork-dimensions__number-label--gang scope-6b9e2e48">
              {" "}
              Price <br className="scope-6b9e2e48" /> per Gang Sheet{" "}
            </div>
          ) : (
            <div
              className={cn("artwork-dimensions__number-label scope-6b9e2e48", {
                "artwork-dimensions__number-label--light": showBorderUI()
              })}
            >
              {" "}
              Total price{" "}
            </div>
          )}
          <div className="artwork-dimensions__static-input scope-6b9e2e48">
            {/* @ts-expect-error TS(2345): Argument of type 'string | null' is not assignable... Remove this comment to see the full error message */}
            {n(totalPrice(), "currency")}
          </div>
        </div>
      </div>
      {showPaddingNote() ? (
        <div className="artwork-dimensions__free-note scope-6b9e2e48">{paddingNote()}</div>
      ) : null}
    </div>
  );
}
